import { useState } from "react";

export const useTabControls = () => {
    const [tab, setTab] = useState(0);

    const handleChangeTab = (event, newValue) => {
        setTab(newValue);
    };

    return {
        tab,
        handleChangeTab
    };
};
